import { connect } from 'react-redux'
import React, { Component } from 'react'
import { createAction } from 'redux-actions'
import VideoItem from './videoItem/VideoItem'
import VideoListHeader from './VideoListHeader'
import { browserHistory, Link } from 'react-router'
import VideoCreator from './VideoCreator'
import Pagination from '../../misc/Pagination'
import { fetchVideos, SELECT, DESELECT, DESELECT_ALL, ZOOM, NOTIFY,  } from '../../actions'
import { processUploadedFiles } from '../../misc/utilities'
import './videoList.css'
import { isMobile, isIOs, getVideosAndPending, getAllShortcodes } from '../../misc/selectors'
import AnimatedLogo from '../../assets/logo.gif'
import debounce from 'lodash/debounce'
import ZoomOverlay from './ZoomOverlay'
import { Helmet } from "react-helmet";
import MdVideoLibrary from 'react-icons/lib/md/video-library'
import { setCookie } from '../../misc/utilities'
import Cookies from 'js-cookie'

const mapStateToProps = (state, ownProps) => {
  const { videos, me, app } = state
  const { query } = ownProps

  return {
    query,
    me,
    app,
    isIOs: isIOs(state),
    pro: me.pro,
    selected: me.selected,
    pages: Math.ceil(videos.total / videos.count),
    // don't return uploads on albums because we don't know which album they're in
    items: getVideosAndPending(state),
    isFetching: videos.isFetching,
    isMobile: isMobile(state),
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  dispatch,
  select: (shortcode) => {
    dispatch(createAction(SELECT)(shortcode))
  },
  deselect: (shortcode) => {
    dispatch(createAction(DESELECT)(shortcode))
  },
  deselectAll: (shortcode) => {
    dispatch(createAction(DESELECT_ALL)(shortcode))
  },
  closeZoom: () => {
    dispatch(createAction(ZOOM)())
  },
  closeNotification: () => {
    dispatch(createAction(NOTIFY)({message: null, upgrade: null, error: null, dismissId: null, info: false}))
  }
})

class VideosList extends Component {
  constructor() {
    super()
    this.state = {
      sort: 'date_added',
      sortd: 'DESC',
      count: 12,
      page: 1,
      search: null,
      playerMuted: true,
      currentSearch: null,
      canShowWelcome: false,
    }

    this.dispatchFetch = this.dispatchFetch.bind(this)
    this.dispatchFetchDebounced = debounce(this.dispatchFetch, 500, { leading: true, trailing: true })
  }

  dispatchFetch(options, force) {
    this.setState({ currentSearch: options.search })
    this.props.dispatch(fetchVideos(options, force))
  }

  fetch(options = {}, force = false, debounced = false) {
    const processedOptions = {
      ...this.state,
      ...options,
    }

    this.setState(options)
    if (debounced) {
      this.dispatchFetchDebounced(processedOptions, force)
    } else {
      this.dispatchFetch(processedOptions, force)
    }
  }

  componentDidMount() {
    this.fetch()

    setTimeout(() => {
      this.setState({ canShowWelcome: true })
    }, 500)

    this.refreshInterval = setInterval(() => {
      console.log('fetch')
      this.fetch({}, true);
    }, 3600000)
  }

  componentWillUnmount() {
    clearInterval(this.refreshInterval)
  }

  isSelected(video) {
    return this.props.selected.contains(video.shortcode)
  }

  render() {
    const { me, query, app, dispatch } = this.props
    return (
      <div>
        <Helmet>
          <title>Dashboard - Streamable</title>
          <meta name="description" content="Upload, edit, and manage your video library."></meta>
          <link rel="canonical" href="https://streamable.com/videos" />
        </Helmet>
        <div className="videos-list">
          <VideoCreator />
          {query.alert ?
            <div className="alert alert-info">
              {query.alert == 'downgrade' ? 'Downgrade successful. ' : query.alert == 'upgrade' ? 'Upgrade successful. ' : query.alert == 'already-subscribed' ? 'You are already subscribed. ' : ''}You're now on the <Link to="/settings">{me.plan_name}</Link> plan. 
              <span onClick={() => browserHistory.push('/videos')} style={{'float': 'right', cursor: 'pointer'}}>Hide</span>
            </div>
          : ''}
          {me.stale && !Cookies.get('hideStaleNotification') ?
            <div className="alert alert-danger">
              You have {me.stale} video{me.stale > 1 ? 's' : ''} that will be deleted soon. 
              <span 
                style={{"marginLeft": '5px', cursor: 'pointer'}}
                onClick={(e) => {
                  browserHistory.push(`/pricing?src_internal=dashboard-stale-notification${me.user_name ? '' : '-anon'}`)
                  e.preventDefault();
                }}>
                  Upgrade Now
              </span> 
              <span 
                onClick={(e) => {
                  setCookie('hideStaleNotification', 'true', 90000); 
                  this.setState({ hideStaleNotification: true })
                  e.preventDefault();
                }} 
                style={{float: 'right', cursor: 'pointer'}}>
                  Dismiss
              </span>
            </div>
          : ''}
          {app.message && (!app.dismissId || !Cookies.get('hideNotification-' + app.dismissId)) ?
            <div className={`alert alert-${app.info ? 'info' : 'warning'}`}>
              {app.message}
              {app.upgrade ?
                <a 
                  href="/pricing"
                  style={{"marginLeft": '5px'}}
                  onClick={(e) => {
                    browserHistory.push(`/pricing?src_internal=${app.message.replace(' ', '-')}`)
                    e.preventDefault();
                  }}>
                    Upgrade Now
                </a> 
              : ''}
              <a 
                href=""
                onClick={(e) => {
                  e.preventDefault();
                  this.props.closeNotification();
                  if (app.dismissId) {
                    setCookie('hideNotification-' + app.dismissId, 'true', 90000); 
                  }
                }} 
                style={{float: 'right'}}>
                  Dismiss
              </a>
            </div>
          : ''}
          <VideoListHeader
            onChange={() => this.fetch({}, true)}
            onSearchChanged={(search) => {
              this.fetch({ search }, false, true)
            }}
            onSortChanged={(sort, sortd) => {
              this.fetch({ sort, sortd })
            }}
            {...this.props}
            {...this.state}
          />
          <div
            className={
              `grid row videos-list-items ${this.props.items.length ? '' : 'empty'}`
            }
          >
            {this.props.items.map((video, i) => (
              <VideoItem
                me={this.props.me}
                key={video.shortcode || video.local_id}
                selectableKey={video.shortcode || video.local_id}
                type='grid'
                video={video}
                selected={this.isSelected(video)}
                onSelect={() => {
                  this.props.select(video.shortcode || video.local_id)
                }}
                onDeselect={() => {
                  this.props.deselect(video.shortcode || video.local_id)
                }}
                isMobile={isMobile}
              />
            ))}
          </div>
          {this.props.isFetching === false && !this.props.items.length && this.state.currentSearch === this.state.search
            ? this.state.currentSearch
                ?
                  <div className="video-list-placeholder">No videos match your search</div>
                :
                  this.state.canShowWelcome ?
                    <div className="row video-list-placeholder-container">
                      <div className="video-list-placeholder">
                        <form
                          ref={r => {
                            if (r) {
                              this.formRef = r
                            }
                          }}
                          style={{ display: 'none' }}
                        >
                          <input
                            key="fileInput"
                            type="file"
                            multiple={false}
                            ref="fileInput"
                            onChange={() => {
                              const files = this.refs.fileInput.files
                              if (!files.length) {
                                return
                              }
                              processUploadedFiles(dispatch, files, null, me.plan_max_length)
                              .then(() => {
                                this.formRef.reset()
                              })
                            }}
                          />
                        </form>
                        
                        <div className="embed-container" onClick={(e) => {
                          e.preventDefault()
                          this.refs.fileInput.click()
                        }}>
                          <div className="placeholder-emphasis" style={{fontSize: '50px', marginBottom: '10px'}}><MdVideoLibrary /></div>
                          <div className="placeholder-emphasis">Select videos to upload.</div>
                          <div style={{color: '#666', fontSize:'14px', marginBottom: '20px'}}>or drag and drop your videos here.</div>
                        </div>
                      </div>
                    </div>
                : ''
            : ''}
          {this.props.pages > 1
            ? <div className="col-12">
              <Pagination
                page={this.state.page}
                pages={this.props.pages}
                onChange={(page) => {
                  this.fetch({ page })
                }}
              />
            </div>
            : ''}
          {this.props.isFetching === true || this.state.currentSearch !== this.state.search
            ? <div className="loading-indicator">
              <img src={AnimatedLogo} alt="presentation" />
            </div>
            : ''}
          {this.props.me.zoomed
            ? 
              <ZoomOverlay
                me={this.props.me}
                video={this.props.me.zoomed}
                onClose={this.props.closeZoom}
                isMobile={this.props.isMobile}
              />
            : ''}
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(VideosList)
